import { BehaviorSubject, Subject } from 'rxjs'

import { Injectable } from '@angular/core'
import { Router } from '@angular/router'

type stateMap = Record<number, boolean>

@Injectable({ providedIn: 'root' })
export class ScopeTabService {
  sectionSelectedStates: stateMap = {}
  _sectionSelectedStates: Subject<stateMap> = new Subject<stateMap>()
  deliverableSelectedStates: stateMap = {}
  _deliverableSelectedStates: Subject<stateMap> = new Subject<stateMap>()
  deliverableSectionSelectedStates: stateMap = {}
  _deliverableSectionSelectedStates: Subject<stateMap> = new Subject<stateMap>()
  componentSelectedStates: stateMap = {}
  _componentSelectedStates: Subject<stateMap> = new Subject<stateMap>()
  departmentSelectedStates: stateMap = {}
  _departmentSelectedStates = new BehaviorSubject<stateMap>({})
  sectionDescriptionStates: stateMap = {}
  deliverableDescriptionStates: stateMap = {}
  componentDescriptionStates: stateMap = {}
  sectionFeeTableStates: stateMap = {}
  deliverableFeeTableStates: stateMap = {}
  componentFeeTableStates: stateMap = {}

  deliverableDragging = false
  stageDragging = false
  dragTargetId: number
  disableDragging = false

  taskOpenStates: stateMap = {}
  scopeCommentsData: Map<number, number>

  get isScopeByRole() {
    return this.router.url.includes('scope-by-role-overview')
  }

  constructor(private router: Router) {}

  resetTableStates() {
    this.sectionSelectedStates = {}
    this._sectionSelectedStates.next({})
    this.deliverableSelectedStates = {}
    this._deliverableSelectedStates.next({})
    this.deliverableSectionSelectedStates = {}
    this._deliverableSectionSelectedStates.next({})
    this.componentSelectedStates = {}
    this._componentSelectedStates.next({})
    this.departmentSelectedStates = {}
    this._departmentSelectedStates.next({})
    this.sectionDescriptionStates = {}
    this.deliverableDescriptionStates = {}
    this.componentDescriptionStates = {}
    this.sectionFeeTableStates = {}
    this.deliverableFeeTableStates = {}
    this.componentFeeTableStates = {}
  }

  resetDeliverablesState() {
    this.deliverableSelectedStates = {}
    this.deliverableSectionSelectedStates = {}
    this.componentSelectedStates = {}
    this.departmentSelectedStates = {}
  }

  toggleSection(sectionId: number) {
    this.sectionSelectedStates[sectionId] = !this.sectionSelectedStates[sectionId]
    this._sectionSelectedStates.next(this.sectionSelectedStates)
  }

  toggleDeliverable(deliverableId: number) {
    this.deliverableSelectedStates[deliverableId] = !this.deliverableSelectedStates[deliverableId]
    this._deliverableSelectedStates.next(this.deliverableSelectedStates)
  }

  toggleDeliverableSection(sectionId: number) {
    this.deliverableSectionSelectedStates[sectionId] = !this.deliverableSectionSelectedStates[sectionId]
    this._deliverableSectionSelectedStates.next(this.deliverableSectionSelectedStates)
  }

  toggleComponent(componentId: number) {
    this.componentSelectedStates[componentId] = !this.componentSelectedStates[componentId]
    this._componentSelectedStates.next(this.componentSelectedStates)
  }

  toggleDepartment(departmentId: number) {
    this.departmentSelectedStates[departmentId] = !this.departmentSelectedStates[departmentId]
    this._departmentSelectedStates.next(this.departmentSelectedStates)
  }

  updateDepartmentSelectedStates(departmentSelectedStates: stateMap) {
    this._departmentSelectedStates.next((this.departmentSelectedStates = { ...departmentSelectedStates }))
  }

  get sectionSelectedStates$() {
    return this._sectionSelectedStates.asObservable()
  }

  get deliverableSelectedStates$() {
    return this._deliverableSelectedStates.asObservable()
  }

  get deliverableSectionSelectedStates$() {
    return this._deliverableSectionSelectedStates.asObservable()
  }

  get componentSelectedStates$() {
    return this._componentSelectedStates.asObservable()
  }

  get departmentSelectedStates$() {
    return this._departmentSelectedStates.asObservable()
  }
}
